module.exports = __webpack_public_path__ + "static/media/control-chofer-gris.2a18a217.png";